import { Flex } from '@chakra-ui/react';

export const ContentContainer = ({ children, color, noPadding }: any) => {
	return (
		<Flex
			justify="center"
			flexDir="column"
		>
			<Flex
				p={{ base: '40px 20px 55px 20px', lg: noPadding ? ' 0' : '88px' }}
				bg={color ?? 'rgb(29,29,29)'}
				justify="center"
			>
				<Flex
					w="100%"
					maxW="1240px"
				>
					{children}
				</Flex>
			</Flex>
		</Flex>
	);
};
